import axios from "axios";
import employees from "../../models/horarios/employees";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getEmployees(id, where) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const params = {
      where,
    };

    return axios
      .get(`${url}/horarioemp/${id}`, { headers, params })

      .then(({ data }) => {
        return data.map((item) => {
          return employees.fromJson(item);
        });
      });
  }

  getEmployeedById(payload) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(
      `${url}/horarioemp/hor/${payload.schedule}&${payload.empId}`,
      {
        headers,
      }
    );
  }

  new(items) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload = {
      operId: parseInt(localStorage.getItem("operId"), 10),
      horarioId: items.schedule,
      fecDesde: items.from + "T00:00:00.000Z",
      segmId: items.segment,
      numSecuencia: items.sequenceNumber,
      segmDespl: parseInt(items.initialDay, 10),
      lista: items.employees,
    };
    if (items.to) {
      payload.fecHasta =
        moment.utc(items.to).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }
    return axios.post(`${url}/horarioemp`, payload, { headers });
  }

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload = {
      desde: data.from + "T00:00:00.000Z",
      haNoEx: data.to == null ? true : false,
      segmId: data.segment,
      numSecuencia: data.sequenceNumber,
      segmDespl: parseInt(data.initialDay, 10),
      fecha: moment().format("YYYY-MM-DD") + "T00:00:00.000Z",
    };
    if (data.to) {
      payload.hasta =
        moment.utc(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }
    return axios.patch(
      `${url}/emphorario/${data.id}&${data.schedule}&${data.oldFrom}`,
      payload,
      { headers }
    );
  }

  delete(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(
      `${url}/emphorario/${data.id}&${data.schedule}&${data.from}`,
      { headers }
    );
  }
}
export default service;
